import { render } from "./IppsuModalCard.vue?vue&type=template&id=78e25ac8&scoped=true"
import script from "./IppsuModalCard.vue?vue&type=script&lang=js"
export * from "./IppsuModalCard.vue?vue&type=script&lang=js"

import "./IppsuModalCard.vue?vue&type=style&index=0&id=78e25ac8&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e25ac8"]])

export default __exports__